// extracted by mini-css-extract-plugin
export default {"title":"Title__title___B9H4g"};